import { useEffect } from "react";
import { Outlet, createFileRoute, useSearch } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { OnboardingLayout } from "@/features/onboarding/components/onboarding-layout/onboarding-layout";
import {
	OnboardingContext,
	useOnboardingState,
} from "@/features/onboarding/hooks/use-onboarding";
import { useAuth } from "@/lib/keycloak/use-auth";

const onboardingSearchSchema = z.object({
	verified: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute("/onboarding")({
	component: OnboardingPage,
	validateSearch: zodValidator(onboardingSearchSchema),
});

function OnboardingPage() {
	const { authenticated, initialized, login } = useAuth();
	const { verified } = useSearch({ from: "/onboarding" });

	useEffect(() => {
		if (initialized && !authenticated && verified === true) {
			void login(window.location.origin + "/onboarding?verified=true");
		}
	}, [initialized, authenticated, verified, login]);

	const onboarding = useOnboardingState({
		showEmailVerifiedPage: verified === true,
	});

	if (verified === true && !authenticated) {
		return null;
	}

	return (
		<OnboardingContext.Provider value={onboarding}>
			<OnboardingLayout>
				<Outlet />
			</OnboardingLayout>
		</OnboardingContext.Provider>
	);
}
